import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Tab } from "@material-ui/core";

import { useStore } from "@store/store";
import {
  FETCH_PRICE_MATRIX,
  FETCH_PRICE_MATRIX_SUCCESS,
  FETCH_PRICE_MATRIX_FAILURE,
  FETCH_CUSTOMER_ID,
  FETCH_CUSTOMER_ID_SUCCESS,
  FETCH_CUSTOMER_ID_FAILURE,
  GET_DAILY_MINIMUM_HOURS,
  GET_DAILY_MINIMUM_HOURS_SUCCESS,
  GET_DAILY_MINIMUM_HOURS_FAILURE,
  GET_DAILY_MINIMUM_HOURS_CONSIGNMENT,
  GET_DAILY_MINIMUM_HOURS_CONSIGNMENT_SUCCESS,
  GET_DAILY_MINIMUM_HOURS_CONSIGNMENT_FAILURE,
  FETCH_PRICE_MATRIX_CONSIGNMENT,
  FETCH_PRICE_MATRIX_CONSIGNMENT_SUCCESS,
  FETCH_PRICE_MATRIX_CONSIGNMENT_FAILURE,
  FETCH_PER_JOB,
  FETCH_PER_JOB_SUCCESS,
  FETCH_PER_JOB_FAILURE,
  FETCH_WAITING_TIME,
  FETCH_WAITING_TIME_SUCCESS,
  FETCH_WAITING_TIME_FAILURE,
  FETCH_FUEL_SURCHARGE_HISTORY,
  FETCH_FUEL_SURCHARGE_HISTORY_SUCCESS,
  FETCH_FUEL_SURCHARGE_HISTORY_FAILURE,
  FETCH_FUEL_SURCHARGE_EFFECTIVE_RATE,
  FETCH_FUEL_SURCHARGE_EFFECTIVE_RATE_SUCCESS,
  FETCH_FUEL_SURCHARGE_EFFECTIVE_RATE_FAILURE,

} from "@utils/actionTypes";
import API from "@services/axios";
import ULDListing from "./table-listing/uld";
import LooseListing from "./table-listing/loose";
import MinimumHours from "./table-listing/minimum-hours";
import FuelSurcharge from "./table-listing/fuel-surcharge";
import Validity from "./table-listing/validity";
import Consignment from "./table-listing/consignment";
import MinimumInvoice from "./table-listing/minimum-invoice-value";
import WaitingTime from "./table-listing/waiting-time";
import PerJob from "./table-listing/per-job";
import { PriceMatrixStyle } from "./style";
import Preload from "./table-listing/preload";
import { rowsPerPageVal, fuelSurcharge } from "@utils/constant";

function PriceMatrix(props) {
  const classes = PriceMatrixStyle();
  const [value, setValue] = useState(0);
  const [state, dispatch] = useStore();
  const { id } = useParams();
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: rowsPerPageVal
  });
  const [sort, setSort] = useState({
    order: "",
    orderBy: ""
  });
  const [existingActiveStartDate, setExistingActiveStartDate] = useState(null);
  const [existingActiveEndDate, setExistingActiveEndDate] = useState(null);
  const [activeFuelSurchargeRate, setActiveFuelSurchargeRate] = useState(fuelSurcharge.defaultValue);
  const [scheduledFuelSurchargeRate, setScheduledFuelSurchargeRate] = useState(null);
  const [scheduledStartDate, setScheduledStartDate] = useState(null);

  const paramsGetFuelSurchargeHistory = useMemo(() => {
    return {
      customerId: id,
      cityId: state?.customer?.customerByIdData?.cities?.id,
      page: pagination.page + 1,
      size: pagination.rowsPerPage,
      order: sort.order !== "" ? sort.order : undefined,
      orderBy: sort.orderBy !== "" ? sort.orderBy : undefined,
    };
  }, [
    sort,
    pagination,
    state?.customer?.customerByIdData,
    id
  ]);

  const handleChangePage = async (event, newPage) => {
    setPagination((prev) => (
      {
        ...prev,
        page: newPage
      }
    ));
    const payload = {
      ...paramsGetFuelSurchargeHistory,
      page: newPage + 1
    };
    getFuelSurchargeHistory(payload);
  };

  const handleChangeRowsPerPage = async (event) => {
    setPagination(prev => (
      {
        ...prev,
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      }
    ));

    const payload = {
      ...paramsGetFuelSurchargeHistory,
      page: 1,
      size: parseInt(event.target.value, 10),
    };
    getFuelSurchargeHistory(payload);
  };

  const handleSorting = async (event, property) => {
    const isAsc = sort.orderBy === property.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      }
    ));
    resetPagination();
    const getParamsGetFuelSurchargeHistory = { ...paramsGetFuelSurchargeHistory };
    delete getParamsGetFuelSurchargeHistory?.order;
    delete getParamsGetFuelSurchargeHistory?.orderBy;
    const payload = {
      ...getParamsGetFuelSurchargeHistory,
      page: 1,
      size: rowsPerPageVal,
      order: isAsc ? "desc" : "asc",
      orderBy: property.sortTitle
    };
    getFuelSurchargeHistory(payload);
  };

  const resetPagination = () => {
    setPagination(prev => (
      {
        ...prev,
        page: 0,
        rowsPerPage: rowsPerPageVal
      }
    ));
  };

  const getFuelSurchargeHistory = (payload) => {
    const params = payload
      ? payload : {
        customerId: id,
        cityId: state?.customer?.customerByIdData?.cities?.id,
        page: 1,
        size: rowsPerPageVal,
      }

    dispatch({ type: FETCH_FUEL_SURCHARGE_HISTORY });
    API.get(`/customers/fuelSurcharge`, { params })
      .then((response) => {
        dispatch({
          type: FETCH_FUEL_SURCHARGE_HISTORY_SUCCESS,
          payload: response.data.data,
        });
        setExistingActiveStartDate(null);
        setScheduledStartDate(null);
        setExistingActiveEndDate(null);

        if (props.updatedFuelSurchargeRate.current) {
          props.tempFuelSurchargeRate.current = null;
        }

        const data = response.data.data.rows.filter(d => d.status === 'Active');
        const scheduledData = response.data.data.rows.filter(d => d.status === 'Scheduled');
        if (data && data.length > 0) {
          setExistingActiveStartDate(data[0]?.startDate);
          setActiveFuelSurchargeRate(data[0]?.fuelSurcharge);
          setExistingActiveEndDate(data[0]?.endDate);
        } else {
          setActiveFuelSurchargeRate(fuelSurcharge.defaultValue);
        }

        if (scheduledData && scheduledData.length > 0) {
          setScheduledFuelSurchargeRate(scheduledData[0]?.fuelSurcharge);
          setScheduledStartDate(scheduledData[0]?.startDate);
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_FUEL_SURCHARGE_HISTORY_FAILURE, payload: error });
      });
  };

  const getFuelSurchargeEffectiveRates = () => {
    dispatch({ type: FETCH_FUEL_SURCHARGE_EFFECTIVE_RATE });
    API.get(`/customers/${id}/fuelSurchargeEffectiveRate`)
      .then((response) => {
        dispatch({
          type: FETCH_FUEL_SURCHARGE_EFFECTIVE_RATE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_FUEL_SURCHARGE_EFFECTIVE_RATE_FAILURE, payload: error });
      });
  };

  // API calling to get price matrix
  let getPriceMatrix = () => {
    dispatch({ type: FETCH_PRICE_MATRIX });
    API.get(`customers/${id}/priceMatrix`)
      .then((response) => {
        dispatch({
          type: FETCH_PRICE_MATRIX_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_PRICE_MATRIX_FAILURE, payload: error });
      });
  };

  // API calling to get consignment price matrix
  let getPriceMatrixConsignment = () => {
    dispatch({
      type: FETCH_PRICE_MATRIX_CONSIGNMENT,
    });
    API.get(`customers/${id}/consignmentPriceMatrix`)
      .then((response) => {
        dispatch({
          type: FETCH_PRICE_MATRIX_CONSIGNMENT_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_PRICE_MATRIX_CONSIGNMENT_FAILURE,
          payload: error,
        });
      });
  };

  // API calling to get customers id
  let apiCall = (isCustomerCall = true) => {
    props.isCustomerDetailCall.current = isCustomerCall;
    dispatch({ type: FETCH_CUSTOMER_ID });
    API.get(`customers/${id}`)
      .then((response) => {
        dispatch({
          type: FETCH_CUSTOMER_ID_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_CUSTOMER_ID_FAILURE, payload: error });
      });
  };

  // API calling to get daily minimum hours
  const getDailyMinimumHours = () => {
    dispatch({
      type: GET_DAILY_MINIMUM_HOURS,
    });
    API.get(`customers/${id}/dailyMinimumHours`)
      .then((response) => {
        dispatch({
          type: GET_DAILY_MINIMUM_HOURS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_DAILY_MINIMUM_HOURS_FAILURE, payload: error });
      });
  };

  // API calling to get daily minimum hours for consignment
  const getDailyMinimumHoursConsignment = () => {
    dispatch({
      type: GET_DAILY_MINIMUM_HOURS_CONSIGNMENT,
    });
    API.get(`customers/${id}/dailyMinimumHoursConsignment`)
      .then((response) => {
        dispatch({
          type: GET_DAILY_MINIMUM_HOURS_CONSIGNMENT_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DAILY_MINIMUM_HOURS_CONSIGNMENT_FAILURE,
          payload: error,
        });
      });
  };

  // API calling to get per job
  const getPerJob = () => {
    dispatch({
      type: FETCH_PER_JOB,
    });
    API.get(`customers/${id}/perJobPriceMatrix`)
      .then((response) => {
        dispatch({
          type: FETCH_PER_JOB_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_PER_JOB_FAILURE, payload: error });
      });
  };

  // API calling to get waiting time data
  const getWaitingTimeData = () => {
    dispatch({
      type: FETCH_WAITING_TIME,
    });
    API.get(`/customers/${id}/waitingTimePriceMatrix`)
      .then((response) => {
        dispatch({
          type: FETCH_WAITING_TIME_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_WAITING_TIME_FAILURE,
          payload: error,
        });
      });
  };

  const resetTempValue = () => {
    props.isCustomerDetailCall.current = true;
    props.tempFuelSurchargeRate.current = null;
    props.tempFuelSurchargeStartDate.current = null;
    props.tempErrorStartDate.current = null;
    props.tempErrorFuelSurchargeRate.current = null;
    props.updatedFuelSurchargeRate.current = true;
  }

  useEffect(() => {
    getPriceMatrix();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect( () => {
    if(
      state.customer?.customerByIdData?.cities?.id &&
      value === 7 &&
      parseInt(id) === state.customer?.customerByIdData?.id
    ) {
      if (props.isCustomerDetailCall.current) {
        getFuelSurchargeHistory();
        getFuelSurchargeEffectiveRates();
      }
    }
  }, [state.customer?.customerByIdData, value, id])

  useEffect(() => {
    if (value === 6) getWaitingTimeData();
    if (value === 3) getPerJob();
    if (value === 4) {
      getDailyMinimumHours();
      getDailyMinimumHoursConsignment();
    }
    if (value === 2) getPriceMatrixConsignment();
    resetTempValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index } = props;
    return (
      value === index && <div className="tab-pannel-wrapper"> {children} </div>
    );
  }
  return (
    <>
      <div className={classes.TabbingWrapper}>
        <div className="white-card tabbing-wrapper">
          <Tabs
            value={value}
            onChange={handleChangeTab}
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="ULD" />
            <Tab label="Loose" />
            <Tab label="Consgt. Price Matrix" />
            <Tab label="Per Job" />
            <Tab label="Daily Min. Hours" />
            <Tab label="Min. Invoice Value" />
            <Tab label="Waiting Time" />
            <Tab label="Fuel Surcharge" />
            <Tab label="Validity" />
            <Tab label="Preload" />
          </Tabs>
          <TabPanel value={value} index={0}>
            <ULDListing getPriceMatrix={getPriceMatrix} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <LooseListing getPriceMatrix={getPriceMatrix} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Consignment
              getPriceMatrixConsignment={getPriceMatrixConsignment}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <PerJob getPerJob={getPerJob} />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <MinimumHours
              getDailyMinimumHours={getDailyMinimumHours}
              getDailyMinimumHoursConsignment={getDailyMinimumHoursConsignment}
              getCustomer={apiCall}
            />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <MinimumInvoice getCustomer={apiCall} />
          </TabPanel>
          <TabPanel value={value} index={6}>
            <WaitingTime
              getWaitingTimeData={getWaitingTimeData}
              getCustomer={apiCall}
            />
          </TabPanel>
          <TabPanel value={value} index={7}>
            <FuelSurcharge
              pagination={pagination}
              sort={sort}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleSorting={handleSorting}
              getFuelSurchargeHistory={getFuelSurchargeHistory}
              getFuelSurchargeEffectiveRates={getFuelSurchargeEffectiveRates}
              fuelSurchargeRate={activeFuelSurchargeRate}
              tempFuelSurchargeRate={props.tempFuelSurchargeRate}
              tempFuelSurchargeStartDate={props.tempFuelSurchargeStartDate}
              tempErrorFuelSurchargeRate={props.tempErrorFuelSurchargeRate}
              tempErrorStartDate={props.tempErrorStartDate}
              updatedFuelSurchargeRate={props.updatedFuelSurchargeRate}
              getCustomer={apiCall}
              existingActiveStartDate={existingActiveStartDate}
              existingActiveEndDate={existingActiveEndDate}
              scheduledFuelSurchargeRate={scheduledFuelSurchargeRate}
              scheduledStartDate={scheduledStartDate}
            />
          </TabPanel>
          <TabPanel value={value} index={8}>
            <Validity getCustomer={apiCall} />
          </TabPanel>
          <TabPanel value={value} index={9}>
            <Preload getCustomer={apiCall} />
          </TabPanel>
        </div>
      </div>
    </>
  );
}
export default React.memo(PriceMatrix);
